import {Form, Select} from 'antd';
import {useState} from 'react';
import {useQuery} from 'react-query';
import api from '../../api';
import MeetingArchiveToggle from '../../components/MeetingArchiveToggle';

const ConfirmationSearch = ({searchParams = {}, setSearchParams}) => {

  const [form] = Form.useForm();
  const [showArchived, setShowArchived] = useState(false);

  const {data: {data: meetings = []} = {}} = useQuery(
    ['search-confirmation-meeting', showArchived],
    () => {
      return api.meetings.meetingList(showArchived ? {archive_only: true} : {});
    }, {
      cacheTime: Infinity,
      onSuccess: ({data}) => {
        if (!data.length) {
          return;
        }
        if (searchParams.meeting && data.some(item => String(item.id) === String(searchParams.meeting))) {
          form.setFieldsValue({
            meeting: searchParams.meeting,
          });
          return;
        }
        const {id: value} = data[0];
        setSearchParams({...searchParams, meeting: value});
        form.setFieldsValue({
          meeting: data[0].id
        });
      }
    });

  const toggleArchived = (value) => {
    setShowArchived(value);
    setSearchParams({});
    form.resetFields();
  };

  const paramChangeHandler = (param) => (value) => {
    setSearchParams({...searchParams, [param]: value});
    return undefined;
  }

  return <>
  <div className="mb-20">
    <MeetingArchiveToggle showArchived={showArchived} onChange={toggleArchived}/>
  </div>
  <Form
    form={form}
    name="search"
    labelCol={{span: 4}}
    wrapperCol={{span: 18}}
  >
    <Form.Item label="Tagung" name="meeting">
      <Select
        style={{width: '100%'}}
        value={searchParams && searchParams.meeting}
        onChange={paramChangeHandler('meeting')}
      >
        {meetings.map(item => <Select.Option key={item.id} value={item.id}>
          {item.name}
        </Select.Option>)}
      </Select>
    </Form.Item>
  </Form>
  </>;
}

export default ConfirmationSearch;
